import { useEffect, useState } from 'react'
import useInstrutor from '../../hooks/useInstrutor'
import { useNavigate } from 'react-router-dom'
import useInstrutorStore from '../../store/useInstrutorStore'

export default function SelectAutoescola() {
  const { GetAutoescolas } = useInstrutor()
  const [autoescolas, setAutoescolas] = useState([])
  const navigate = useNavigate()
  const instrutorStore = useInstrutorStore()
  const instrutor = instrutorStore.instrutor

  useEffect(() => {

    async function fetchAutoescolas() { 
      if(!instrutor) return;
      const res = await GetAutoescolas(instrutor.instrutor_id)
      setAutoescolas(res || [])
    }
    fetchAutoescolas()
  }, [GetAutoescolas, instrutor])

  const selecionarAutoescola = (id) => {
    //console.log("Autoescola selecionada:", id);
    sessionStorage.setItem('autoescola_id', id)
    navigate('/homeinstrutor')
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md flex flex-col gap-4">
        <h1 className="text-2xl font-bold text-center mb-2">
          Selecione sua autoescola
        </h1>
        <p className="text-sm text-gray-500 text-center mb-4">
          Escolha a unidade onde você vai atuar hoje
        </p>

        {autoescolas.map((autoescola) => (
          <button
            key={autoescola.autoescola_id}
            onClick={() => selecionarAutoescola(autoescola.autoescola_id)}
            className="
              w-full text-left bg-white rounded-2xl p-4 shadow-sm
              border border-gray-200
              flex flex-col gap-2
              hover:shadow-md hover:border-primary/40 hover:scale-[1.01]
              active:scale-[0.98]
              transition-all duration-200
            "
          >
            <div className="flex justify-between items-center">
              <div>
                <h2 className="text-lg font-semibold capitalize">
                  {autoescola.nome}
                </h2>
                <p className="text-sm text-gray-500">
                  {autoescola.endereco}
                </p>
              </div>

              <div className="flex items-center justify-center w-9 h-9 rounded-full bg-primary/10 text-primary">
                <span className="material-icons text-base">arrow_forward</span>
              </div>
            </div>

            <span className="text-xs text-gray-400 mt-1">
              Toque para continuar
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}
